const typeNamespace = 'QUESTION_';
export const REQUEST = `${typeNamespace}REQUEST`;
export const STORY_QUESTION_GROUP = `${typeNamespace}QUESTION_GROUP`;

export const SET_LAST_CACHE_TIME = `${typeNamespace}LAST_CACHE_TIME`;


